import Dashboard from "../pages/Dashboard.vue"
import Logs      from "../pages/Logs.vue"
import Workflow  from "../pages/Workflow.vue"
import { createWebHashHistory, createRouter } from "vue-router"

const routes = [
    { name: 'dashboard',       path: '/',                  component: Dashboard,  meta: { title: 'OptimizeFlow',                   'mark': 'dashboard' } },
    { name: 'workflow-create', path: '/workflows/create',  component: Workflow,   meta: { title: 'OptimizeFlow - Create Workflow', 'mark': 'workflow' }  },
    { name: 'workflow-edit',   path: '/workflows/:id',     component: Workflow,   meta: { title: 'OptimizeFlow - Edit Workflow',   'mark': 'workflow' }  },
    { name: 'logs',            path: '/logs',              component: Logs,       meta: { title: 'OptimizeFlow - Logs',            'mark': 'logs'     }  },
]

const router = createRouter({
    history: createWebHashHistory(),
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    },
    routes:  routes,
})

// Run on route change, and find meta title
router.beforeEach((to, from, next) => {
    const route = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
    if (route) {
        document.title = route.meta.title

        // Mark navigation as active
        let path   = '/' + route.path.replace(/\//g, '#')
        let $items = jQuery('#toplevel_page_op-flow .wp-submenu a')
        let mark   = route.meta.mark
        let marked = false

        // Loop through items
        $items.each(function(index, el) {
            let $el  = jQuery(el)
            let href = $el.attr('href')
            let page = href.replace('admin\.php?page=op-flow\/\#', '')

            if (page === mark && path !== '/#') {
                marked = true;
                $el.closest('li').addClass('current')
            } else {
                $el.closest('li').removeClass('current')
            }
        })

        // Mark dashboard
        if (! marked) {
            jQuery('#toplevel_page_op-flow .wp-submenu li.wp-first-item').addClass('current')
        }
    }

    next()
})

export default router
